// Single source of truth for all factual content on the site.
// RULE: nothing here may be invented. Every item traces back to the brief.

// The 12 explicitly included elements (point 6). Order preserved.
export const INCLUDED = [
  "Votre connexion internet fibre professionnelle, avec bascule automatique sur un secours 4G si elle tombe",
  "Le pare-feu qui protège votre réseau, installé, configuré et surveillé par nos soins",
  "L'équipement réseau installé et configuré",
  "Votre téléphonie d'entreprise (dans la limite d'un usage professionnel normal), avec conservation de vos numéros actuels",
  "La messagerie professionnelle et la suite bureautique",
  "La protection de chaque ordinateur contre les virus, les rançongiciels et les logiciels non autorisés",
  "Deux clés de sécurité physiques par personne, offertes",
  "La gestion sécurisée des mots de passe de toute l'équipe",
  "La sauvegarde de vos ordinateurs et de votre messagerie",
  "La sensibilisation régulière de vos équipes aux tentatives d'arnaque",
  "La surveillance permanente de vos systèmes",
  "Le support illimité et la maintenance",
];

// The exhaustive list of guarantees (point 7). Do not add any.
export const GUARANTEES = [
  { title: "Support illimité", text: "Par téléphone et à distance, du lundi au vendredi de 8h à 18h." },
  { title: "Intervention garantie", text: "Sous 4 heures ouvrées, et 2 heures si votre activité est à l'arrêt." },
  { title: "Surveillance permanente", text: "Vos systèmes sont surveillés 24h/24, 7j/7." },
  { title: "Deux visites par an", text: "Deux interventions sur site incluses chaque année." },
  { title: "Matériel défectueux", text: "Le remplacement du matériel défectueux est pris en charge." },
];

// Offer definition (point 6) — une seule formule, un seul prix.
export const OFFERS = {
  serenite: {
    name: "Sérénité",
    tagline: "Toute votre informatique, gérée et sécurisée, pour un prix unique.",
    text: "Un seul interlocuteur, une seule facture, et la même protection pour toutes les entreprises de 3 à 9 postes. Vous conservez vos ordinateurs actuels ; l'infrastructure réseau neuve est installée par nos soins.",
  },
};

// Option additionnelle (pas une formule) : renouvellement du matériel en leasing.
export const HARDWARE_OPTION = {
  name: "Renouvellement de matériel",
  price: "60 € HT/mois/poste",
  text: "Ordinateur fixe ou portable en leasing : votre équipement est renouvelé automatiquement tous les trois ans. Financement accessible via notre partenaire bancaire.",
};

// "Ce que vous payez déjà, en désordre" (point 5). No figures allowed.
export const PAY_ALREADY = {
  left: {
    title: "Ce que vous payez déjà, séparément",
    items: [
      "L'abonnement internet",
      "Les lignes téléphoniques",
      "Les licences de messagerie et de bureautique",
      "Un antivirus",
      "Le dépanneur qu'on appelle en urgence",
      "Le remplacement des ordinateurs quand ils lâchent",
    ],
    footer: "Plusieurs prestataires, plusieurs factures, plusieurs interlocuteurs.",
  },
  right: {
    title: "Ce que vous ne payez pas et que vous n'avez pas",
    items: [
      "Une sauvegarde dont quelqu'un vérifie qu'elle fonctionne",
      "Une protection contre le vol de mot de passe",
      "Une surveillance de vos systèmes",
      "Une équipe formée à reconnaître les tentatives d'arnaque",
      "Quelqu'un qui répond quand ça ne marche pas",
    ],
    footer: "Le plus important est souvent ce qui manque.",
  },
  bridge: "Vous payez déjà pour la première colonne. Nous ajoutons la seconde, et vous n'avez plus qu'un seul interlocuteur.",
};

// FAQ (point 10). Answers written from the contractual facts provided.
export const FAQS = [
  {
    q: "Que se passe-t-il si je change d'avis dans trois ans ?",
    a: "Le contrat se renouvelle tacitement, avec un préavis de résiliation de trois mois : vous n'êtes donc jamais enfermé, il vous suffit de nous prévenir trois mois à l'avance. En fin de contrat, le matériel loué est restitué — nous nous chargeons de la reprise, de l'effacement sécurisé de vos données et de la remise d'une attestation. Vos clés de sécurité, elles, sont offertes : vous en restez propriétaire et ne les restituez jamais. Et à l'échéance normale, le matériel est simplement remplacé par du neuf sans augmentation de votre budget mensuel : c'est le fonctionnement prévu de l'offre, pas une renégociation.",
  },
  {
    q: "Suis-je vraiment obligé de prendre toute l'offre ?",
    a: "Oui, et c'est volontaire. C'est précisément parce que tout est réuni au même endroit que vous n'avez qu'un seul interlocuteur, une seule facture, et exactement le même niveau de protection qu'une entreprise plus grande. Découper l'offre reviendrait à recréer le désordre que nous supprimons.",
  },
  {
    q: "Mes ordinateurs actuels sont encore corrects, dois-je les remplacer ?",
    a: "Non. C'est justement le rôle de la formule Sérénité : nous gérons et sécurisons vos ordinateurs actuels et installons l'infrastructure réseau neuve. Si vous préférez repartir sur du matériel neuf renouvelé tous les trois ans, l'option renouvellement de matériel est faite pour cela.",
  },
  {
    q: "Combien de temps prend la mise en place ?",
    a: "Tout commence par un état des lieux qui nous permet de préparer votre installation dans le détail. Nous convenons ensuite ensemble d'un calendrier de mise en service adapté à votre activité, pour que la bascule se fasse en douceur et sans interruption pour vos équipes.",
  },
  {
    q: "Que couvre exactement le support illimité ?",
    a: "Un support illimité par téléphone et à distance, du lundi au vendredi de 8h à 18h, avec la maintenance de votre parc. S'y ajoutent une surveillance de vos systèmes 24h/24 et 7j/7, une intervention garantie sous 4 heures ouvrées (2 heures si votre activité est à l'arrêt), deux interventions sur site chaque année et la prise en charge du remplacement du matériel défectueux.",
  },
  {
    q: "Que se passe-t-il si un salarié perd sa clé de sécurité ?",
    a: "Chaque personne dispose de deux clés : une principale et une de secours. En cas de perte, le salarié n'est jamais bloqué : il utilise immédiatement sa clé de secours. Les clés sont offertes à l'installation et le client en devient propriétaire — elles ne sont jamais restituées. Le remplacement d'une clé perdue coûte environ 60€ HT. Il est aussi possible de commander une clé supplémentaire directement sur le site du fabricant. Les clés ne se clonent pas : chaque compte doit être supprimé de la clé de secours puis réattribué un par un sur les deux clés. Le client peut effectuer cette opération seul, ou être accompagné par notre équipe.",
  },
  {
    q: "Travaillez-vous avec des entreprises de plus de 9 postes ?",
    a: "Oui. Nos tarifs affichés couvrent jusqu'à 9 postes, mais nous accompagnons aussi des entreprises plus grandes — jusqu'à une vingtaine de postes, et au-delà sur étude. Contactez-nous : nous établissons un devis sur mesure, avec exactement le même niveau de service.",
  },
];

// Network equipment clarification (point 4). Use verbatim wherever the network
// equipment is described. Never state a fixed number without "jusqu'à".
export const NETWORK_NOTE =
  "L'équipement réseau standard est compris : un routeur-pare-feu, jusqu'à deux points d'accès wifi et un switch, installés et configurés. Si la configuration de vos locaux en demande davantage, nous le chiffrons pendant notre premier échange — jamais après la signature.";

// Guest wifi + captive portal (point 5). Separate service, NOT in the main
// included list. For businesses that welcome the public.
export const WIFI = {
  eyebrow: "Vous accueillez du public ?",
  title: "Votre wifi visiteurs est compris, et vous êtes en règle.",
  context:
    "Dès que vous ouvrez votre wifi à vos clients ou visiteurs, vous devenez responsable de cet accès. La loi française vous oblige alors à conserver les journaux de connexion pendant un an — ce que la plupart des établissements qui offrent du wifi ignorent complètement.",
  audience:
    "Ce service concerne les entreprises qui accueillent du public : hôtels, restaurants, cafés, salles d'attente, espaces de coworking, commerces.",
  items: [
    "Une page d'accueil wifi à vos couleurs, que vos visiteurs voient en se connectant",
    "Un accès gratuit ou payant selon votre choix, avec gestion des codes d'accès",
    "Un réseau visiteurs totalement séparé du vôtre : vos clients ne voient jamais vos données",
    "La conservation des journaux de connexion pendant un an, comme la loi vous y oblige",
    "L'ensemble installé, configuré et administré par nous",
  ],
};

// Legal / contact. Values provided in the initial brief.
// NOTE: the v2 brief marked several of these as [À COMPLÉTER]; kept from brief #1, to be confirmed.
export const COMPANY = {
  brand: "Umbo",
  legalName: "Nord VOIP SASU",
  legalForm: "société par actions simplifiée unipersonnelle (SASU)",
  capital: "500 €",
  siret: "892 000 241 00018",
  address: "679 avenue de la République, 59800 Lille",
  phone: "03 20 49 02 04",
  phoneHref: "+33320490204",
  email: "contact@umbocyber.fr",
  region: "Hauts-de-France",
  city: "Lille",
};
